import { Check, Loader2 } from 'lucide-react';

import { Badge } from '@nesso/ui/primitives/badge';
import { Button } from '@nesso/ui/primitives/button';
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from '@nesso/ui/primitives/card';

import { formatPlanTerms, type PaidPlan } from '@/entities/subscription';
import { formatCurrencyFromCents } from '@/shared/lib/format-utils';

type PickPlanCardProps = {
    plan: PaidPlan;
    actionLabel: string;
    actionVariant: 'default' | 'outline';
    disabled: boolean;
    showCheck: boolean;
    isSelecting: boolean;
    showMostPopular: boolean;
    caption?: string;
    onSelect: () => void;
};

export function PickPlanCard({
    plan,
    actionLabel,
    actionVariant,
    disabled,
    showCheck,
    isSelecting,
    showMostPopular,
    caption,
    onSelect,
}: PickPlanCardProps) {
    const planTerms = formatPlanTerms(plan);

    return (
        <Card>
            <CardHeader>
                <div className="flex items-center gap-2.5">
                    <CardTitle className="whitespace-nowrap">{plan.name}</CardTitle>
                    {showMostPopular && <Badge variant="outline">Most Popular</Badge>}
                </div>
                {planTerms && <CardDescription>{planTerms}</CardDescription>}
            </CardHeader>
            <CardContent className="mt-auto flex items-center gap-3 py-4">
                <span className="text-3xl font-semibold">
                    {formatCurrencyFromCents(plan.basePriceCents)}
                </span>
                <span className="text-sm leading-none text-muted-foreground">
                    per
                    <br />
                    month
                </span>
            </CardContent>
            <CardFooter className="flex-col gap-3">
                <Button
                    variant={actionVariant}
                    className="w-full"
                    disabled={disabled}
                    onClick={onSelect}
                >
                    {showCheck && <Check />}
                    {isSelecting && <Loader2 className="animate-spin" />}
                    {actionLabel}
                </Button>
                {caption && <p className="text-center text-sm text-muted-foreground">{caption}</p>}
            </CardFooter>
        </Card>
    );
}
